module.exports = __webpack_public_path__ + "icon-arrow-down.svg?c631fdee6b86adc70ac1492eb135e93b";